module.exports = __webpack_public_path__ + "logo_groupeaa.png?58a67b966f69c6dabcc2cf2fe1bb5bb0";